<template>
  <button
    :class="[
      'bg-bkk-50 flex items-center justify-center text-lg rounded-full h-12 w-12',
      variantClasses,
    ]"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

type ButtonVariant = "solid" | "white";

const props = withDefaults(
  defineProps<{
    variant?: ButtonVariant;
  }>(),
  {
    variant: "solid",
  }
);

const variantClasses = computed(() => {
  switch (props.variant) {
    case "solid":
      return "";
    case "white":
      return "rounded-full bg-white border-[4px] border-bkk-50 hover:bg-bkk-10 focus:ring-bkk-100";
    default:
      return "";
  }
});
</script>
